import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { ROTAS_WP } from './Variables';
import { AdminRoutes } from './AdminRoutes';
import { PostsRoutes } from './PostsRoutes';

export function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROTAS_WP.DASHBOARD} element={<AdminRoutes />} />
        <Route path={ROTAS_WP.POST_NEW} element={<PostsRoutes />} />
        <Route path={ROTAS_WP.POST_EDIT} element={<PostsRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}
